import { getLocalIANATimeZone, isLocalTimeZone, normalizeIANATimeZone } from '@chronosphereio/core';

export function isTimeZoneOverridden(userTimeZoneIANA: string, IANA: string): boolean {
  const normalizedUserTimeZone = normalizeIANATimeZone(userTimeZoneIANA);
  const normalizedTimeZone = normalizeIANATimeZone(IANA);

  const isUserTimeZoneLocal =
    isLocalTimeZone(normalizedUserTimeZone) || normalizedUserTimeZone === getLocalIANATimeZone();
  const isTimeZoneLocal = isLocalTimeZone(normalizedTimeZone) || normalizedTimeZone === getLocalIANATimeZone();

  if (!isUserTimeZoneLocal && isTimeZoneLocal) {
    return true;
  }
  if (isUserTimeZoneLocal && !isTimeZoneLocal) {
    return true;
  }
  if (isUserTimeZoneLocal && isTimeZoneLocal) {
    return false;
  }
  return normalizedUserTimeZone !== normalizedTimeZone;
}
